<div class="side-tab-label-container" #tabListContainer>
    <div class="side-tab-list" #tabList>
        <div class="side-tab-labels">
            <ng-content></ng-content>
        </div>
    </div>
</div>